import { t } from "i18next";
import { z } from "zod";

import { EMBED_DOMAIN_MAX_COUNT, isValidEmbedDomain } from "./embedDomains";

export interface EmbedProfileFormValues {
  label: string;
  domains: string[];
  is_default: boolean;
}

export function buildEmbedProfileSchema(): z.ZodType<
  EmbedProfileFormValues,
  EmbedProfileFormValues
> {
  return z.object({
    label: z
      .string()
      .min(1, t("editor-organization:embedProfiles.form.errors.labelRequired")),
    domains: z
      .array(
        z
          .string()
          .refine(
            isValidEmbedDomain,
            t("editor-organization:embedProfiles.form.errors.domainInvalid"),
          ),
      )
      .min(
        1,
        t("editor-organization:embedProfiles.form.errors.domainsRequired"),
      )
      .max(
        EMBED_DOMAIN_MAX_COUNT,
        t("editor-organization:embedProfiles.form.errors.domainsMax"),
      ),
    is_default: z.boolean(),
  });
}
